import React, { useState, memo } from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import {
    FullScreenIcon,
} from "../../../../components/Icons/Icons";
import styles from "./Header.module.css";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);
const Header = ({ screen, setScreen, isFullScreen, setIsFullScreen, onlyVideo }) => {
    // eslint-disable-next-line
    const [listNumber, setListNumber] = useState([
        1, 4, 9, 16, 25, 36, 49, 64, 81, 100,
    ]);
    const { t } = useTranslation();
    const handleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
    };
    const changeScreen = (index) => {
        setScreen(index);
    };
    return (
        <div className={cx("content", isFullScreen ? "full" : "")}>
            <div className={cx("right")}>
                {
                    !onlyVideo && <div className={cx("custom")}>
                        <span className={cx("text")}>{t("playback.screenView")}</span>
                        {listNumber &&
                            listNumber.map((item, index) => (
                                <span
                                    key={index}
                                    onClick={(e) => changeScreen(item)}
                                    className={cx("number", screen === item ? "active" : "", `sc-${item}`)}
                                    style={{ background: isFullScreen ? 'rgba(255, 255, 255, 0.15)' : '' }}
                                >
                                    {item}
                                </span>
                            ))}
                    </div>
                }
                <div className={cx("full-screen")}>
                    <span className={cx("text")}>{isFullScreen ? t("playback.minisize") : t("playback.fullsize")}</span>
                    <span onClick={handleFullScreen} className={cx("icon")}>
                        {isFullScreen ? <FullScreenIcon color="white" /> : <FullScreenIcon color="black" />}
                    </span>
                </div>
            </div>
        </div >
    );
};
Header.propTypes = {
    screen: PropTypes.number.isRequired,
    setScreen: PropTypes.func.isRequired,
    isFullScreen: PropTypes.bool.isRequired,
    setIsFullScreen: PropTypes.func.isRequired,
};

export default memo(Header);
